export default "__VITE_ASSET__55a24c83__"